// extracted by mini-css-extract-plugin
module.exports = {"Root":"Root_Root__IFjI7"};